// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg[data-v-03f2f237] {\r\n    width: 130px;\r\n    height: 183px;\n}\r\n", ""]);
// Exports
module.exports = exports;
